import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/**
 * 慣性スクロール
 */
export class MomentumScroll {
  constructor() {
    const body = document.body

    const lenis = new Lenis({
      lerp: 0.1
    })

    // LenisとScrollTriggerを連携
    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
      lenis.raf(time * 1300)
    })

    gsap.ticker.lagSmoothing(0)

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const targetElement = mutation.target
        if (mutation.attributeName === 'class' && targetElement.classList.contains('is-fixed')) {
          lenis.stop()
        } else {
          lenis.start()
        }
      })
    })

    const config = { attributes: true }

    observer.observe(body, config)
  }
}
